/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// src/components/ui/tooltip.jsx
import * as React from "react";

export function Tooltip({ content, children, className = "" }) {
  return (
    <div className={`group relative inline-block ${className}`}>
      {/* The element you hover over */}
      <span className="cursor-help">{children}</span>

      {/* Tooltip box */}
      <div
        className="
          invisible 
          group-hover:visible 
          absolute 
          bottom-full 
          left-1/2 
          transform -translate-x-1/2 
          mb-2 
          whitespace-nowrap 
          rounded 
          bg-textPrimary       князь      // Using textPrimary for a dark background (could be a specific tooltip bg color)
          px-2 py-1 
          text-xs text-backgroundBody  // Using backgroundBody for light text on dark bg
          shadow-lg 
          z-10
        "
      >
        {content}
      </div>
    </div>
  );
}
